import * as React from 'react';
var useState = React.useState;

var noop = function noop() {};

var useHover = function useHover(element) {
  var _a = useState(false),
      state = _a[0],
      setState = _a[1];

  var onMouseEnter = function onMouseEnter(originalOnMouseEnter) {
    return function (event) {
      (originalOnMouseEnter || noop)(event);
      setState(true);
    };
  };

  var onMouseLeave = function onMouseLeave(originalOnMouseLeave) {
    return function (event) {
      (originalOnMouseLeave || noop)(event);
      setState(false);
    };
  };

  if (typeof element === 'function') {
    element = element(state);
  }

  var el = React.cloneElement(element, {
    onMouseEnter: onMouseEnter(element.props.onMouseEnter),
    onMouseLeave: onMouseLeave(element.props.onMouseLeave)
  });
  return [el, state];
};

export default useHover;